import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { EnderecoApiService } from "./shared/endereco-api.service";
import { EnderecoFormComponent } from "./endereco-form/endereco-form.component";
import { EnderecoService } from "./shared/endereco.service";
import { EstadoApiService } from "./estados/shared/estado-api.service";
import { CidadeApiService } from "./cidades/shared/cidade-api.service";
import { TipoLogradouroApiService } from "./tipos-logradouro/shared/tipo-logradouro-api.service";

@NgModule({
    imports: [
        SharedModule
    ],
    providers: [
        EnderecoApiService,
        EnderecoApiService,
        EnderecoService,
        EstadoApiService,
        CidadeApiService,
        TipoLogradouroApiService
    ],
    declarations: [
        EnderecoFormComponent
    ],
    exports: [
        EnderecoFormComponent
    ]
})
export class EnderecosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/enderecos/enderecos.module.ts
 **/